import React from 'react';

import Text from '../text/text';
import { makeClassNames } from '../../../utils/styles';
import './substitute-player.scss';

const classNames = () =>
  makeClassNames({
    player: 'substitute-players-content__player',
  });

const cn = classNames();

export interface ISubstitutePlayer {
  type: string;
  name: string;
  playerUrl?: string;
  enterTime?: number;
  points?: number;
  mvp?: boolean;
}

const SubstitutePlayer = (props: ISubstitutePlayer) => {
  const { type, name, playerUrl, enterTime, points, mvp } = props;

  return (
    <div className={cn.player}>
      <div>
        <Text
          color="blue"
          fontSize="16"
          fontWeight="500"
          tag={playerUrl ? 'a' : 'span'}
          href={playerUrl || undefined}
          dataAttributes={{ intcmp: `skysport_${type}_nome-giocatore-bottom_detail-link` }}
        >
          {name}
        </Text>{' '}
        {mvp && (
          <>
            <Text color="blue" fontSize="16" fontWeight="500">
              (MVP)
            </Text>{' '}
          </>
        )}
        <Text color="blue" fontSize="12" fontWeight="400">
          dal {enterTime}&rsquo;
        </Text>
      </div>
      <div>
        <Text color="blue" fontSize="16" fontWeight="500">
          {points?.toLocaleString('it-IT') || 'S.V.'}
        </Text>
      </div>
    </div>
  );
};

export default SubstitutePlayer;
